/*
 * Forge Maestro
 * (c) Honeywell
 */

import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { IconBase } from '../IconBase.js';
import { IconName } from '../IconName.enum.js';

const CheckIcon = forwardRef((props, ref) => {
    const { className = '', title, strokeWidth = 1.5 } = props;
    return (jsx(IconBase, Object.assign({ ref: ref, className: className, title: title, name: IconName.Check }, { children: jsx("path", { strokeWidth: strokeWidth, strokeLinecap: "round", strokeLinejoin: "round", d: "M20 6 9 17l-5-5" }) })));
});

export { CheckIcon };
//# sourceMappingURL=CheckIcon.js.map
